import Vue from "vue";

export const features = {
  __test_true: true,
  __test_false: false,
  REPORTS: true,
  TEACHERS: true,
  APP_REFFERALS: false,
  APP_NOTIFICATIONS: false,
  ACTIVITY_BC: true,
  TABLE_DOWNLOAD: false,
  TABLE_IMPORT: false
};

export type Features = typeof features;
export type FeatureKeys = keyof Features;

export default function isFeatureEnabled(feature: FeatureKeys) {
  return features[feature] === true;
}
